import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformPool } from '../pools/pools.transformers';
import { AdminPoolsCollection } from './admin-pools.types';

export function adminPoolsReducer(
  state: CollectionStateSlice<AdminPoolsCollection> = {},
  action: CollectionActions<AdminPoolsCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'adminPools') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<AdminPoolsCollection>(
          state,
          transformIntoDocuments(result.pool_models, transformPool),
          order,
          ref,
        );
      }
      return state;
    }
    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'adminPools') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<AdminPoolsCollection>(
          state,
          transformIntoDocuments([result.pool_model], transformPool),
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
